import { SeatLookup, SeatMapRow } from '../charter.types';

/**
 * Generates a lookup table for seats indexed by cabin-aware key.
 * Key format: `${cabin}:${seatId}` to avoid conflicts when multiple cabins have seats with the same ID.
 */
export const generateSeatLookup = (rows: Array<SeatMapRow>): SeatLookup => {
  const lookup: SeatLookup = {};

  rows.forEach((row) => {
    row.seats.forEach((seat) => {
      // Use cabin-aware key to avoid conflicts between cabins with overlapping seat IDs
      const seatKey = `${seat.cabin}:${seat.primaryColumn ?? seat.seatId}`;
      lookup[seatKey] = seat;
    });
  });

  return lookup;
};

/**
 * Helper to generate the cabin-aware lookup key for a seat.
 */
export const getSeatLookupKey = (cabin: string, seatId: string): string => {
  return `${cabin}:${seatId}`;
};
